export default __webpack_public_path__ + "static/media/table-with-four-people.3581f906.png";